import { FC } from 'react';
import { BlockPage, BlockPageProps } from '../../../../routings/pages/BlockPage/BlockPage';
import { Icons } from '@silverfort/sf-components';
import AccessAnalysisCloudBlockPageImage from '../../assets/accessAnalysisCloudBlockPageImage.png';

const topics: BlockPageProps['rightContent']['topics'] = [
    'Map all access paths and effective privileges, whether used or not',
    'Get real-time visibility into access paths and protection gaps across AD and hybrid environments',
    'Understand which apps are accessed, by which users, and with what permissions',
    'Easily identify unused apps or access and decide whether to remove or protect them'
];

export const AccessAnalysisCloudBlockPage: FC = () => {
    return (
        <BlockPage
            leftContent={{
                image: AccessAnalysisCloudBlockPageImage,
                title: 'Access Intelligence for Cloud',
                titleIntroText: 'Introducing'
            }}
            rightContent={{
                accessLink: 'https://www.silverfort.com/cloud-access-analysis-signup',
                description:
                    'helps you proactively reduce risk by uncovering unused or unprotected access paths before they’re exploited.',
                icon: Icons.Key,
                title: 'Uncover and Eliminate Cloud Access Risk',
                topics,
            }}
        />
    );
};
